import * as config from '../../config';
import ErrorScreen from '../error_screen/error_screen';
import * as DomUtils from '../../util/dom_utils';
import {default as Splunk, SPLUNK_LEVELS} from '../report/splunk';
import Youbora from '../report/youbora';
import LanguageManager from '../language_manager/language_manager';
//import {Concurrency} from '../the_platform';

const DEFAULT_GENERAL_ERROR_CODE = 571119;
const DEFAULT_OPTIONS = {
    stopPlayer: true,
    showErrorScreen: true,
    logSplunk: true,
    logYoubora: true,
    override: false,
    attachScreenTo: config.playerElementId,
    code: DEFAULT_GENERAL_ERROR_CODE
};
export const DEFAULT_ERROR = {code: DEFAULT_GENERAL_ERROR_CODE}; // the rest gets automatically updated on throw

// Export Errors
export default {

    /**
     * Adds options to the current instance, or creates a new one if it does not yet exists
     * @param {Object} options
     * @param {Object} [options.adapter]
     * @param {string} [options.environment]
     * @param {string} [options.sessionToken]
     */
    addOptions(options) {
        Object.assign(this, options);
    },

    /**
     * Handles all application errors.
     *
     * @param {Object} options
     * @param {String} options.message
     * @param {String} options.code
     * @param {Object} [options.redirect=false]
     * @param {Number} [options.timeout=5000]
     * @param {String} [options.title="An error occured"]
     * @param {boolean} [options.stopPlayer=true]
     * @param {boolean} [options.showErrorScreen=true]
     * @param {boolean} [options.logSplunk=true]
     * @param {boolean} [options.logYoubora=true]
     * @param {boolean} [options.override=false] - If there is an existing error screen, this will be overriden by this one.
     * @param {string} [options.attachScreenTo=default] - the Element to attach the error screen to. defaults to config.playerElementId
     * @param {*} [developerMessage=null]
     * @throws StarzPlayerException
     */
    throwError(options, developerMessage = null) {
        options = Object.assign(DEFAULT_OPTIONS, options);
        const title = options.title || LanguageManager.get('error_title');
        const message = options.message || LanguageManager.get('error_571107_generic');
        const code = options.code || DEFAULT_GENERAL_ERROR_CODE;

        if (this.once) {
            console.log('Error can only thrown once.');
            return false;
        }
        this.once = true;
        options.stopPlayer && this._stopPlayer();

        options.showErrorScreen && this._showErrorScreen({
            title: title,
            message: message,
            redirect: options.redirect,
            attachToElement: options.attachScreenTo
        });

        this._printError(developerMessage);

        options.logSplunk && this._sendToSplunk({
            title: title,
            message: message,
            code: code,
            dev: developerMessage
        });

        options.logYoubora && this._sendToYoubora({
            message: message,
            code: code
        });

        if (options.redirect) {
            const timeout = options.redirect.timeout === undefined ? 5000 : options.redirect.timeout;
            const redirectTo = () => {
                if (options.redirect.location) {
                    window.location = options.redirect.location;
                } else {
                    window.history.back();
                }
            };
            setTimeout(() => redirectTo(), timeout);
        }

        if (options.stopPlayer) {
            this._stopModules();
            throw new Error('StarzPlayerException');
        }

        return false;
    },

    /**
     * Handles warnings
     * @param {Object} options
     * @param {Number} options.code The error code
     * @param {String} options.message The error message
     * @param {*} developerMessage The developersObject
     */
    handleWarning(options, developerMessage) {
        console.warn('SPLUNK -- Sending warning to splunk', options, developerMessage);
        this._sendToSplunk({
            code: options.code || DEFAULT_GENERAL_ERROR_CODE,
            dev: developerMessage,
            level: SPLUNK_LEVELS.warning
        });
    },

    _stopModules() {
        //Concurrency.stopUpdateCycle();
    },
    /**
     * Sends an error to splunk
     * @param {Object} error
     * @param error.message
     * @param error.title
     * @param error.code
     * @param error.dev - error specifics for dev
     * @param [error.level] - splunklevel
     */
    _sendToSplunk(error) {
        Splunk.send(error);
    },

    /**
     * Sends an error to youbora
     * @param {Object} error
     * @param {String|Number} error.code
     * @param {String} error.message
     * @private
     */
    _sendToYoubora(error) {
        Youbora.sendError(error);
    },

    /**
     * Displays an error on the screen
     * @param {Object} options
     * @param {String} [options.title]
     * @param {String} options.message
     * @param {String} options.redirect
     * @param {Number} options.seconds
     * @param {string} [options.attachToElement=default] - the Element to attach the error screen to. defaults to config.playerElementId
     * @private
     */
    _showErrorScreen(options) {
        if (options.attachToElement && typeof options.attachToElement === 'object') {
            let redirect = {};

            if (options.redirect) {
                redirect.redirect_message = LanguageManager.get('redirect_timeout');
                redirect.seconds = parseInt(options.redirect.timeout / 1000);
            }

            ErrorScreen.show(Object.assign({
                title: options.title,
                message: options.message,
                attachToElement: options.attachToElement
            }, redirect));
        } else {
            DomUtils.waitForElement('id', config.playerElementId, (success, element) => {
                options.attachToElement = element;
                this._showErrorScreen(options);
            });
        }
    },

    /**
     * Stops the player. In case no adapter is added it can't so it will return with a warning.
     * @private
     */
    _stopPlayer() {
        if (!this.adapter) {
            return console.warn('Cannot stop player: adapter is not set');
        }
        this.adapter.destroy();
        DomUtils.waitForElement('id', config.playerElementId, (success, element) => {
            success && DomUtils.removeChildrenOfElement(element);
        });
    },

    /**
     * Prints the error to the console. Usually the dev object
     * @param e
     * @private
     */
    _printError(e) {
        if (console.warn) {
            console.warn(e);
        } else {
            if (console.error) {
                console.error(e);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/error_handler/error_handler.js